export enum PURCHASEORDER_STATUS {
  APPROVED = "approved",
  PENDING = "pending",
  REJECTED = "rejected",
  CANCELED = "canceled",
  PRE_APPROVED = "pre-approved",
  PENDING_RELEASE = "pending-release",
}

export enum TYPE_PAYMENT {
  Pix = "pix",
  Boleto = "boleto",
  Transferencia = "transferencia",
  Credito = "credito",
  Cheque = "cheque",
  Dinheiro = "dinheiro",
}

export type IPurchaseOrder = {
  _id?: string;
  code: string;
  isCounted?: boolean;
  supplier?: { value: string; label: string };
  status: string;
  companyId: string;
  supplierName: string;
  supplierId: string;
  description: string;
  deliveryDate?: Date | string;
  itens: IPurchaseOrderItem[];
  financial: IPurchaseOrderFinancial;
  createdAt: Date;
  votesApproved?: { requestorName: string; requestorEmail: string }[];
  requestorId: string;
  requestorName: string;
  requestorEmail: string;
  referenceId: string;
  qtdInstalment: number;
  observations?: string;
  disproportionatePrice?:
    | {
        lastPrice: number;
        price: number;
      }
    | Record<string, never>[];
};

export type SchedulePayment = {
  stakeholderId: string;
  description: string;
  dueDate: Date;
  scheduleDate: Date;
  categories: { categoryId: string; value: string }[];
  costCenters: { costCenterId: string }[];
  instalment: {
    installmentNumber: string;
    value: number;
    dueDate: Date;
  };
  reference: string;
};

export const emptyPurchaseOrder = (): IPurchaseOrder => ({
  code: "",
  status: "",
  companyId: "",
  supplier: { value: "", label: "" },
  itens: [],
  description: "",
  supplierId: "",
  supplierName: "",
  isCounted: false,
  financial: {
    categoryId: "",
    categoryName: "",
    costCenterId: "",
    costCenterName: "",
    value: 0,
    instalment: [
      {
        installmentNumber: "1",
        value: 0,
        dueDate: new Date(),
      },
    ],
    billetFiles: "",
    nfFiles: "",
    paymentProofFiles: "",
    typePayment: TYPE_PAYMENT.Boleto,
    discountAmount: 0,
    valueOfLabor: 0,
    deliveryForecast: undefined,
    qtdInstalment: 1,
  },
  createdAt: new Date(),
  requestorId: "",
  requestorName: "",
  requestorEmail: "",
  referenceId: "",
  qtdInstalment: 1,
});

export type IPurchaseOrderTransfer = {
  name: string;
  agency: string;
  accountBank: string;
};

export type IPurchaseOrderFinancial = {
  _id?: string;
  categoryId: string;
  categoryName: string;
  costCenterId: string;
  costCenterName: string;
  expectedDate?: Date | string;
  value: number;
  instalment: {
    installmentNumber: string;
    value: number;
    dueDate: string | Date;
  }[];
  typePayment: TYPE_PAYMENT;
  discountAmount?: number;
  valueOfLabor?: number;
  taxes?: number;
  deliveryForecast?: Date;
  qtdInstalment: number;
  pixKey?: string;
  billetFiles?: FileList | string;
  nfFiles?: FileList | string;
  paymentProofFiles?: FileList | string;
  transfer?: IPurchaseOrderTransfer;
  checkNumber?: string;
};

export type IPurchaseOrderItem = {
  _id?: string;
  description: string;
  qtd: number;
  value: number | string;
  productId?: string;
};
